/**
 * The Hindi wording of the audited ADR-0043 opt-in (rule 83), in Devanagari.
 *
 * Owner rule 2026-10-28: Hindi UI text is Devanagari, not Roman Hinglish. Until
 * 2026-10-29 every Hindi opt-in (the value-moment cards on kundali, chat,
 * matching, dasamsa and rashi, plus the in-chat capture's opt-in mode) showed
 * this same Hindi sentence in Roman letters. This module holds it in Devanagari,
 * word for word: the same heading, the same two channels (WhatsApp and email),
 * the same upay framing and the same STOP instruction.
 *
 * Nothing the seeker agrees to changed, so the recorded copy version is still
 * MARKETING_CONSENT_COPY_VERSION (jyotish_updates_v3). v3 has always covered an
 * English and a Hindi rendering of one agreement. Changing what this copy ASKS
 * for (a channel, the framing, the STOP line) needs a new version, exactly as
 * for the English copy.
 *
 * "WhatsApp" and "STOP" stay Latin: one is the brand, the other is the literal
 * keyword the unsubscribe handler matches.
 */
export const HINDI_CONSENT_COPY = {
  hi: {
    readingHeading: "आपका AI ज्योतिषी इस कुंडली को याद रखेगा",
    matchHeading: "आपका AI ज्योतिषी इस मिलान को याद रखेगा",
    readingBody:
      "इस कुंडली के राशिफल और ग्रह अपडेट WhatsApp और ईमेल पर पाएं — सही समय पर उपाय सुझावों के साथ। आप कभी भी STOP कर सकते हैं।",
    matchBody:
      "इस मिलान से जुड़े अपडेट WhatsApp और ईमेल पर पाएं — सही समय पर उपाय सुझावों के साथ। आप कभी भी STOP कर सकते हैं।",
    cta: "हाँ, भेजें",
    saving: "सेव हो रहा है...",
    skip: "अभी नहीं",
    placeholder: "मोबाइल नंबर",
    countryLabel: "देश कोड",
    invalid: "सही मोबाइल नंबर डालें।",
    needsPhone: "WhatsApp अपडेट के लिए अपना मोबाइल नंबर डालें।",
    error: "अनुमति सेव नहीं हुई। दोबारा कोशिश करें।",
    success: "अपडेट चालू हैं। बंद करने के लिए कभी भी STOP भेजें।",
  },
} as const;

/** The in-chat capture's opt-in mode (ChatContactCapture, placement chat-inline). */
export const HINDI_CHAT_INLINE_OPTIN_COPY = {
  hi: {
    headline: "आपका AI ज्योतिषी इस कुंडली को याद रखेगा",
    subtext:
      "इस कुंडली के राशिफल और ग्रह अपडेट WhatsApp और ईमेल पर पाएं — सही समय पर उपाय सुझावों के साथ। कभी भी STOP करें।",
    placeholder: "10 अंकों का मोबाइल नंबर",
    cta: "हाँ, WhatsApp पर भेजें",
    skip: "बाद में",
    saved: "🙏 WhatsApp अपडेट चालू हैं। बंद करने के लिए कभी भी STOP भेजें।",
  },
} as const;
